import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { useContext } from "react";
import { StripeContext } from "../../../../../../context/StripeContext.context";
import { NewCheckoutI } from "../../../../../../api/request/Lead/Interfaces/DataInterface.response";
import { numberFormatPayment } from "../../../../../../utils/Utils";
import { WalletType } from "./PaymentMethodPicker.component";
import { PricesV3T } from "../types";

interface StickyMobileCTAProps {
  checkout: NewCheckoutI;
  prices?: PricesV3T;
  isButtonDisabled: boolean;
  selectedMethod: WalletType;
  translate: (key: string) => string;
}

const StickyMobileCTA = ({
  checkout,
  prices,
  isButtonDisabled,
  selectedMethod,
  translate,
}: StickyMobileCTAProps) => {
  const { handleSubmit } = useContext(StripeContext);

  const period = (checkout.period?.toLowerCase() || "monthly") as
    | "monthly"
    | "yearly";
  const isYearly = period === "yearly";
  const periodPrices = prices?.[period];
  const totalFull = periodPrices?.real ?? checkout.regularPrice;
  const totalNow =
    periodPrices?.promoted ??
    (checkout.isPromoted ? checkout.priceToPay : checkout.regularPrice);
  const isPromoted = totalNow < totalFull;

  // For wallet methods (Google Pay / Apple Pay), the inline WalletButton handles
  // the action. Hiding the sticky CTA prevents a duplicate or non-functional button.
  if (selectedMethod !== "card") return null;

  const disabled = isButtonDisabled;

  return (
    <div className="paymentV3StickyCTA">
      <div className="paymentV3StickyCTA__row">
        <div className="paymentV3StickyCTA__total">
          <span className="paymentV3StickyCTA__totalLabel">
            {translate("paymentV3.summary.total")}
          </span>
          <span className="paymentV3StickyCTA__totalValue">
            {isPromoted && (
              <span className="paymentV3StickyCTA__totalOld">
                {numberFormatPayment(totalFull)} €
              </span>
            )}
            <span>{numberFormatPayment(totalNow)} €</span>
            <span className="paymentV3StickyCTA__totalSub">
              /
              {translate(
                isYearly
                  ? "paymentV3.summary.freq.shortYear"
                  : "paymentV3.summary.freq.shortMonth"
              )}
            </span>
          </span>
        </div>
        <ButtonDS
          label={translate("paymentV3.section.cta.verifyShort")}
          leftIcon="LockIcon"
          onClick={() => handleSubmit()}
          disabled={disabled}
          className="paymentV3StickyCTA__button"
        />
      </div>
      <div className="paymentV3StickyCTA__disclaimer">
        <GlobalIcon iconName="InfoIcon" size="XS" color="#8E8E8E" />
        <span>{translate("paymentV3.section.cta.refunded")}</span>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
